import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['amountInput', 'fspCommissionInput'];
  static values = {
    fspCommissionPercentage: Number
  };

  handleAmountChange() {
    const amount = this.amountInputTarget.value
    const fspCommission = amount.replace(',', '.').replaceAll(' ', '') * this.fspCommissionPercentageValue

    this.fspCommissionInputTarget.value = fspCommission.toFixed(2)
  }
}
